/* Far Afield AW26 lookbook: Shopify-safe market-aware product status.
   Load as a theme asset, not inside the blog post HTML editor.
   Product handles are read from existing /products/<handle> links because
   the blog rich text editor can remove data-handle attributes.
*/
(function () {
  'use strict';

  function initialiseAw26Lookbook() {
    var lookbook = document.querySelector('.fa-aw26-lookbook');
    if (!lookbook) return;

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/';
    if (root.slice(-1) !== '/') root += '/';

    var country = String(
      document.documentElement.getAttribute('data-country') ||
      (window.Shopify && window.Shopify.country) || ''
    ).toUpperCase();

    // Keep this independent of the product's Shopify stock and published status.
    var unavailableInUs = new Set([
      'melton-station-jacket-navy',
      'portree-smock-dark-grey-ripstop',
      'gurans-zipper-jacket-blue',
      'kier-flecked-rib-polo-green',
      'bayer-flecked-rib-roll-neck-blue',
      'multi-fleck-dieter-knit-grey',
      'nepalese-sunset-dieter-knit-multi',
      'waldo-boucle-v-neck-sequoia',
      'appa-contrast-polo-knit-navy',
      'lok-kala-pinto-vest-multi',
      'lok-kala-knit-shirt-rust',
      'zigger-knit-shirt-camel',
      'gurans-albers-cardigan-dark-grey',
      'combin-stripe-jumper-grey',
      'benny-polo-knit-brown',
      'hamish-ribbed-jumper-rust',
      'mustang-stripe-polo-knit-rust',
      'clifford-waffle-polo-knit-aqua',
      'lok-kala-two-pocket-shirt-light-blue',
      'half-zip-day-shirt-green',
      'pop-over-day-shirt-light-blue',
      'mustang-check-larry-shirt-brown',
      'day-shirt-light-grey',
      'jiva-stripe-laurel-5-panel-cap-burnt-orange',
      'carlos-cap-brown',
      'gurans-neckerchief-light-tan',
      'gurans-neckerchief-navy',
      'pate-bagh-neckerchief-aqua-grey',
      'pate-bagh-neckerchief-navy',
      'kalo-knitted-hat-light-brown',
      'multi-fleck-beanie-grey',
      'two-tone-boucle-beanie-rust-light-brown',
      'basket-weave-beanie-dark-grey',
      'multi-fleck-triangle-scarf-grey',
      'two-tone-boucle-scarf-rust-light-brown',
      'basket-weave-scarf-dark-grey',
      'coup-trouser-sand',
      'dekk-trouser-camel',
      'chambers-trouser-rust',
      'bangdel-check-two-pocket-shirt-off-white'
    ]);

    // No knitted products are hard-coded as Coming soon. Shopify decides.
    // Static non-linked rows (Edmund, Logo Sweatshirt, Talbot, tiger sweatshirt)
    // stay as Coming soon until their product handles are supplied.
    var grouped = new Map();
    lookbook.querySelectorAll('a.fa-product-row[href]').forEach(function (row) {
      var match = row.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;
      var handle = decodeURIComponent(match[1]);
      if (!grouped.has(handle)) grouped.set(handle, []);
      grouped.get(handle).push(row);
    });

    function setState(row, state, url) {
      var status = row.querySelector('.fa-status');
      row.classList.remove('fa-live', 'fa-coming-soon', 'fa-sold-out', 'fa-unavailable-market');
      if (state === 'live') {
        row.classList.add('fa-live');
        row.setAttribute('href', url);
        row.removeAttribute('aria-disabled');
        row.removeAttribute('tabindex');
        if (status) status.textContent = 'Shop';
        return;
      }
      row.removeAttribute('href');
      row.setAttribute('aria-disabled', 'true');
      row.setAttribute('tabindex', '-1');
      if (state === 'unavailable') {
        row.classList.add('fa-unavailable-market');
        if (status) status.textContent = 'Unavailable in the US';
      } else if (state === 'sold-out') {
        row.classList.add('fa-sold-out');
        if (status) status.textContent = 'Sold out';
      } else {
        row.classList.add('fa-coming-soon');
        if (status) status.textContent = 'Coming soon';
      }
    }

    grouped.forEach(function (rows, handle) {
      var url = root + 'products/' + encodeURIComponent(handle);
      if (country === 'US' && unavailableInUs.has(handle)) {
        rows.forEach(function (row) { setState(row, 'unavailable', url); });
        return;
      }
      // Disable links until the current market's product data has been checked.
      rows.forEach(function (row) { setState(row, 'coming-soon', url); });
      fetch(url + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product not accessible in this market');
          return response.json();
        })
        .then(function (product) {
          var state = product && product.available ? 'live' : 'sold-out';
          rows.forEach(function (row) { setState(row, state, url); });
        })
        .catch(function () {
          rows.forEach(function (row) { setState(row, 'coming-soon', url); });
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAw26Lookbook, { once: true });
  } else {
    initialiseAw26Lookbook();
  }
})();
